import { useQuery } from '@tanstack/react-query';
import { portalGet } from '@/lib/portal/customerClient';
import { usePortalAuthStore } from '@/stores/portalAuth.store';

export interface PortalEquipment {
  id: string;
  equipmentNumber: string;
  name: string;
  category: string;
  make: string | null;
  model: string | null;
  serialNumber: string | null;
  installDate: string | null;
  expectedLifespanYears: number | null;
  endOfLifeDate: string | null;
  condition: string;
  conditionNotes: string | null;
  warrantyPartsEnd: string | null;
  warrantyLaborEnd: string | null;
}

/** The signed-in contact's installed equipment (safe projection). */
export function usePortalEquipment() {
  const token = usePortalAuthStore((s) => s.token);
  return useQuery({
    queryKey: ['portal', 'equipment', token],
    queryFn: () => portalGet<PortalEquipment[]>('/api/portal/equipment'),
    enabled: Boolean(token),
    retry: false,
  });
}
